<template>
	<app-page>
		<app-heading :title="isNew ? 'New Key' : key.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;">
				<app-section-actions>
					<app-button v-if="isNew" type="submit" small color="success">Generate</app-button>
					<app-button v-else type="submit" small color="primary">Update</app-button>
					<app-button type="cancel" small :to="{ name: 'api-keys' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Name"
					v-model="key.name"
					:errors="errors.name"
				/>
				<input-select
					label="Role"
					v-model="key.role"
					:items="roles"
					:errors="errors.role"
				/>
				<input-combobox
					class="mb-4"
					label="Resource Restrictions"
					can-add
					chips
					multiple
					no-selection
					v-model="key.resources"
					:errors="errors.resources"
				/>
			</app-section>
		</app-form>
		<app-dialog
			maxWidth="400"
			title="API key created"
			:value="showNew"
		>
			<app-dialog-body ref="dialogBodyKey">
				<app-row class="mt-4">
					<app-cell>
						<b>Please conserve the secret as it will not be available afterwards.</b>
					</app-cell>
				</app-row>
				<app-divider class="mb-4" />
				<app-row>
					<app-cell><b>Key: </b></app-cell>
					<app-cell>
						<app-button
							flat
							small
							class="ma-0 text-lowercase"
							icon="far fa-copy"
							icon-right
							@click="onKeyClick(key.key)"
						>{{key.key}}</app-button>
					</app-cell>
				</app-row>
				<app-row>
					<app-cell><b>Secret: </b></app-cell>
					<app-cell>
						<app-button
							flat
							small
							class="ma-0 text-lowercase"
							icon="far fa-copy"
							icon-right
							@click="onKeyClick(key.secret, true)"
						>{{key.secret}}</app-button>
					</app-cell>
				</app-row>
			</app-dialog-body>
			<app-dialog-footer>
				<app-button type="button" color="primary" @click="onClick">Done</app-button>
			</app-dialog-footer>
		</app-dialog>
	</app-page>
</template>

<script>
export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			this.roles = await this.$ravello.graphql('roles').datasource().query()
			if (!this.isNew) {
				const key = await this.$ravello.request()
					.to('apikeys')
					.to(this.id)
					.get()
				this.key = {
					name: key.name || '',
					role: key.role,
					resources: key.resources || [],
				}
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			roles: [],
			key: {
				name: '',
				role: '',
				key: '',
				secret: '',
				resources: [],
			},
			resources: [],
			errors: {},
			showNew: false,
		}
	},
	computed: {
		id() {
			return this.$route.params.key
		},
		isNew() {
			return this.id === 'generate'
		},
	},
	methods: {
		onClick() {
			this.showNew = false
			this.$router.push({ name: 'api-keys' })
		},

		async onKeyClick(key, secret = false) {
			const container = this.$refs.dialogBodyKey.$el
			try {
				await this.$copyText(key, container)
				this.$notifications.pushSnackbar(`${secret ? 'Secret' : 'API Key'} copied to clipboard!`)
			} catch (err) {
				this.$notifications.pushAlert('error', err.message)
			}
		},

		getPayload() {
			return {
				name: this.key.name,
				role: this.key.role,
				resources: this.key.resources,
			}
		},

		async createKey() {
			this.$store.dispatch('app/startLoading')
			try {
				const newKey = await this.$ravello.request().to('apikeys').create(this.getPayload())
				this.$notifications.pushAlert('success', 'API key successfully generated')
				this.$store.dispatch('app/stopLoading')
				this.key.key = newKey.key
				this.key.secret = newKey.secret
				this.showNew = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},

		async updateKey() {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request().to('apikeys').to(this.id).update(this.getPayload())
				this.$notifications.pushAlert('success', 'API key successfully updated')
				this.$store.dispatch('app/stopLoading')
				this.$router.push({ name: 'api-keys' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},

		onSubmit() {
			if (this.isNew) {
				this.createKey()
			} else {
				this.updateKey()
			}
		},
	},
}
</script>
